export const selectRecommendationsState = (state) => state.recommendations;

export const selectRecommendationItems = (state) =>
  selectRecommendationsState(state)?.items || [];

export const selectRecommendationsLoading = (state) =>
  selectRecommendationsState(state)?.loading;

export const selectRecommendationsCursor = (state) =>
  selectRecommendationsState(state)?.cursor;

export const selectRecommendationsHasMore = (state) =>
  selectRecommendationsState(state)?.hasMore;
